import type { ReactNode } from "react";
import { motion, type HTMLMotionProps } from "framer-motion";

type CardProps = HTMLMotionProps<"div"> & {
  children: ReactNode;
  /** Highlight accent — adds a colored left border. */
  accent?: "none" | "success" | "warning" | "danger" | "info";
  /** Animate on mount (fade-in-up). */
  animate?: boolean;
};

const accentStyles: Record<NonNullable<CardProps["accent"]>, string> = {
  none: "",
  success: "border-l-4 border-l-emerald-400",
  warning: "border-l-4 border-l-amber-400",
  danger: "border-l-4 border-l-red-400",
  info: "border-l-4 border-l-brand-400",
};

export function Card({ children, accent = "none", animate = false, className = "", ...rest }: CardProps) {
  const Comp = animate ? motion.div : motion.div;
  const motionProps = animate
    ? {
        initial: { opacity: 0, y: 8 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.24, ease: "easeOut" as const },
      }
    : {};
  return (
    <Comp className={`card ${accentStyles[accent]} ${className}`} {...motionProps} {...rest}>
      {children}
    </Comp>
  );
}
